import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';

import BadgeActiveTimeRange from 'src/components/Badge/BadgeActiveTimeRange';
import Loading from 'src/components/Loading';
import UUID from 'src/components/UUID';
import username from 'src/util/decorators/username';

/**
 * Description
 * @param {object} props
 * @returns {React.ReactElement} - AdminPropertyList component
 */
function AdminPropertyShowPropertyUser(props) {
  if (!props) {
    return <Loading />;
  }

  const { propertyUser } = props;
  const {
    id, externalIdentifier, active, user,
  } = propertyUser;
  const {
    id: userId, externalIdentifier: userExternalIdentifier, email: userEmail, active: userActive,
  } = user;

  return (
    <tr>
      <th scope="row" className="text-right">
        <UUID uuid={id} url={`/admin/property-users/${id}`} />
      </th>
      <td>
        <BadgeActiveTimeRange active={active} />
      </td>
      <td>{externalIdentifier}</td>
      <th scope="row" colSpan={2}>
        <Link to={`/admin/users/${userId}`}>
          {username(user)}
          <br />
          {userEmail}
        </Link>
      </th>
      <td>
        <BadgeActiveTimeRange active={userActive} />
      </td>
      <td colSpan={2}>
        <UUID uuid={userId} />
        <br />
        {userExternalIdentifier}
      </td>
    </tr>
  );
}

AdminPropertyShowPropertyUser.propTypes = {
  propertyUser: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

AdminPropertyShowPropertyUser.defaultProps = {
  propertyUser: null,
};

export default AdminPropertyShowPropertyUser;
